module.exports = __webpack_public_path__ + "assets/img/KeyReport_001.da6e96d5-ps.jpg";